import { render, staticRenderFns } from "./CallScriptsTab.vue?vue&type=template&id=10b9fc54&"
import script from "./CallScriptsTab.vue?vue&type=script&lang=js&"
export * from "./CallScriptsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports